<template>
  <a-select v-model="selectedValue" show-search placeholder="请选择代码仓库" :filter-option="false" label-in-value @search="handleSearch" @change="handleChange">
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="project in gitlabProjects" :key="project.git_id" :value="project.git_id">
      {{ project.name }}
      <span class="http-url"> ({{ project.http_url }})</span>
    </a-select-option>
  </a-select>
</template>

<script>
import { debounce } from 'lodash';
import { gitlabProjectList } from '@/api/system/service';

export default {
  name: 'GitlabProjectSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      gitlabProjects: [],
      selectedValue: this.value
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val && typeof val === 'object') {
          this.selectedValue = val;
        } else {
          this.selectedValue = { label: null, value: null, key: null };
        }
      },
      immediate: true
    }
  },
  created() {
    this.getGitlabProjects();
  },
  methods: {
    getGitlabProjects(keyword = '') {
      this.loading = true;
      this.gitlabProjects = [];
      gitlabProjectList({
        filter: keyword,
        page_number: 1,
        page_size: 20
      })
        .then(res => {
          this.gitlabProjects = res.data.gitlab_projects;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleSearch: debounce(function (value) {
      this.getGitlabProjects(value);
    }, 500),

    handleChange(value) {
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="less" scoped>
.http-url {
  color: rgb(133, 133, 133);
}
</style>
